/* eslint max-classes-per-file: 0 */

import { AxiosRequestConfig } from 'axios'
import {
  RoadmapDirection as Data,
  RoadmapDirectionCollection as Collection,
} from '@/typings/api/RoadmapDirection'
import { Roadmap } from '@/typings/api/Roadmap'
import {
  BaseApiParams as BP,
  BaseApiResponse as BR,
} from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'

interface RoadmapDirectionApiParams extends BP {
  roadmap_id: Roadmap['id'];
}

export class RoadmapDirectionsApi extends BaseApiAuth<Data, Collection, RoadmapDirectionApiParams> {
  protected readonly endpoint = 'publications/roadmaps/:roadmap_id/directions';
}

export class RoadmapDirectionsFeedApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'publications/directions/feed';

  public create<D extends BP, R extends BR<Data> = BR<Data>>(
    data: D, config?: AxiosRequestConfig,
  ) {
    const path = 'create/'
    const [url] = this.getUrl(path, data)
    return this.request<never, R>('POST', url, { data, ...config })
  }

  public delete(id: Data['id'], config: AxiosRequestConfig = {}) {
    const path = `${id}/delete/`
    const [url] = this.getUrl(path)
    return this.request<never>('POST', url, config)
  }
}
